if ( !$.fn.quartz ) {
	(function($){  
	 /**
	  * Plug in to tame form elements
	  * @param section is a parent element containing HTML form elements
	  * by Joshua Smith http://quartzui.com
	  */
	 $.fn.quartz = function() {
		
		// add a viewport
		if ( !$('head meta[name="viewport"]').length ) {
			$('head').append('<meta name="viewport" content="width=device-width, maximum-scale=1.0" />');
		}
		
		$('input').each(function(){
			switch ( $(this).attr('type') ) {
				case 'file' :
					if ( !$(this).closest('.ui-file').length ) {
						$(this).wrap('<span class="ui-action ui-file" />').closest('.ui-file').prepend('<span>Select File</span>');
					}
					$(this).change(function(){
						var quartz_split_file = $($(this)).val().split(/\\/).pop();
						$(this).closest('.ui-file').find('span').html('File: '+((quartz_split_file)?quartz_split_file:$(input).val()));
					});
					break;
				case 'checkbox' :
					if ( !$(this).closest('.ui-checkbox').length ) {
						$(this).wrap('<span class="ui-field ui-option ui-check" />').closest('.ui-check').append('<span class="ui-option-icon"></span>');
					}
					break;
				case 'radio' :
					if ( !$(this).closest('.ui-radio').length ) {
						$(this).wrap('<span class="ui-field ui-option ui-radio" />').closest('.ui-radio').append('<span class="ui-option-icon"></span>');
					}
					break;
				case undefined :
					$(this).attr('type','text');
					$(this).addClass('ui-field');
					break;
				case 'reset' :
				case 'button' :
					$(this).addClass('ui-action');
					break;
				case 'submit' :
					if ( !$(this).hasClass('ui-action') ) {
						$(this).addClass('ui-action ui-action-main');
					}
					break;
				default: 
					$(this).addClass('ui-field');
					break;
			}
		});
		$('textarea').addClass('ui-field');
		$('button').addClass('ui-action');
		$('label').each(function(){
			if ( $(this).find('input').length ) {
				$(this).addClass('ui-option-label');
			} else {
				$(this).addClass('ui-label');
			}
		});
		
		$('select').each(function(){
			if ( $(this).attr('multiple') ) {
				$(this).addClass('ui-field');
			} else if ( !$(this).closest('.ui-select').length ) {
				$(this).wrap('<span class="ui-action ui-select" />');
			}
		});
		
		if ( $('html').hasClass('ie') ) {
			// ie leaves an ugly focus effect
			$(document).on('change','.ui-select select',function(){
				$(this).blur();
			});
		}
	 };  
	})(jQuery);
	
	$(document).ready(function(){$('body').quartz();});
}